import { useState, useEffect } from 'react';

export const useSearchParams = () => {
  const [searchParams, setSearchParams] = useState(
    new URLSearchParams(window.location.search),
  );

  useEffect(() => {
    const handlePopState = () => {
      setSearchParams(new URLSearchParams(window.location.search));
    };

    window.addEventListener('popstate', handlePopState);

    return () => {
      window.removeEventListener('popstate', handlePopState);
    };
  }, []);

  const setParam = (key, value) => {
    const newSearchParams = new URLSearchParams(searchParams);
    newSearchParams.set(key, value);

    window.history.pushState({}, '', `?${newSearchParams.toString()}`);
    setSearchParams(newSearchParams);
  };

  const deleteParam = (key) => {
    const newSearchParams = new URLSearchParams(searchParams);
    newSearchParams.delete(key);

    window.history.pushState({}, '', `?${newSearchParams.toString()}`);
    setSearchParams(newSearchParams);
  };

  // Define a get method to retrieve a specific query parameter
  const getParam = (key) => {
    return searchParams.get(key);
  };

  return { searchParams, set: setParam, delete: deleteParam, get: getParam };
};
